import React from 'react';
import { ClearIndicatorProps, components } from 'react-select';

import { Icons } from '@icons/icons';

import colors from '@constants/colors';

export const ClearIndicator = (props: ClearIndicatorProps, isFilterStyle: boolean) => {
	return (
		<components.ClearIndicator {...props}>
			<span className='close'>
				{Icons.clearMultiselect({ color: isFilterStyle ? colors.white : colors.indigo70 })}
			</span>
		</components.ClearIndicator>
	);
};
